module.exports = __webpack_public_path__ + "static/media/children-obese.889c0727.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/children-obese.svg
// module id = 881
// module chunks = 0 1